export const FETCH_HOUSE_STYLES_START = 'FETCH_HOUSE_STYLES_START';
export const FETCH_HOUSE_STYLES_SUCCESS = 'FETCH_HOUSE_STYLES_SUCCESS';
export const FETCH_HOUSE_STYLES_ERROR = 'FETCH_HOUSE_STYLES_ERROR';

export const MODIFY_HOUSE_STYLES_REQUEST = 'MODIFY_HOUSE_STYLES_REQUEST';
export const MODIFY_HOUSE_STYLES_SUCCESS = 'MODIFY_HOUSE_STYLES_SUCCESS';
export const MODIFY_HOUSE_STYLES_ERROR = 'MODIFY_HOUSE_STYLES_ERRORS';
